module.exports = __webpack_public_path__ + "img/landos-mark__list--pink.png?b5ef8598ff1c057509944127b3e847be";